import React, { useState } from 'react'
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap'
import useReactSelectCustomStyle from '../../hooks/useReactSelectCustomStyle';
import Select from "react-select";
import { addUser } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getClients } from '../../slices/ManageClient/thunk';

export default function AddContactPersonModal({ contactPersonAddModalOpen, setcontactPersonAddModalOpen, toggleContactPersonAddModal, clientCompanyId }) {

    const dispatch = useDispatch();

    const userRole = 'CLIENT_ADMIN';

    const [submittingForm, setSubmittingForm] = useState(false);

    const [addUserInputValues, setAddUserInputValues] = useState({ ssoId: "", firstName: "", lastName: "", email: "", contactNumber: "", designation: "", professionalQualification: "", password: "" });

    const handleContactPersonAddInputsChange = (event) => {
        setAddUserInputValues({ ...addUserInputValues, [event.target.name]: event.target.value })
    }

    const handleAddUser = async (e) => {
        e.preventDefault();

        if (submittingForm) return;

        try {
            const { ssoId, firstName, lastName, email, contactNumber, designation, professionalQualification, password } = addUserInputValues;

            if (!ssoId) {
                toast.error('SSO ID is required');
                return;
            } if (ssoId.length < 5 || ssoId.length > 12) {
                toast.error('SSO ID must be 5 to 12 characters long');
                return;
            } 

            else if (!firstName) {
                toast.error('First Name is required');
                return;
            } else if (firstName.length > 15) {
                toast.error('First Name cannot exceed 15 characters');
                return;
            }


            else if (!lastName) {
                toast.error('Last Name is required');
                return;
            } else if (lastName.length > 15) {
                toast.error('Last Name cannot exceed 15 characters');
                return;
            }

            else if (!email) {
                toast.error('Email is required');
                return;
            } else if (email.length > 50) {
                toast.error('Email cannot exceed 50 characters');
                return;
            } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i.test(email)) {
                toast.error('Please enter a valid email address');
                return;
            }

            else if (!contactNumber) {
                toast.error('Contact Number is required');
                return;
            } else if (!/^\d{8,15}$/.test(contactNumber)) {
                toast.error('Contact Number must be between 8 and 15 digits');
                return;
            }

            else if (!designation) {
                toast.error('Designation is required');
                return;
            } else if (designation.length > 50) {
                toast.error('Designation must not exceed 50 characters');
                return;
            }

            else if (!professionalQualification) {
                toast.error('Professional qualification is required');
                return;
            } else if (professionalQualification.length > 50) {
                toast.error('Professional qualification must not exceed 50 characters');
                return;
            }

            if (!password) {
                toast.error('Password is required');
                return;
            } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"\'<>,.?/-]).{8,15}$/.test(password)) {
                toast.error('Wrong password format. Password must be 8 to 15 characters, with at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character');
                return;
            }


            const data = { ssoId, firstName, lastName, email, contactNumber, designation, professionalQualifications: professionalQualification, clientCompanyId, password }

            setSubmittingForm(true);

            const apiResponse = await addUser(data, userRole);
            if (apiResponse.status === 201) {
                toast.success(apiResponse.data);
                setcontactPersonAddModalOpen(false);
                dispatch(getClients());
            }
            else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            }
            else if (apiResponse.status === 409) {
                toast.error(apiResponse.data);
            }
            else {
                toast.error('Something went wrong while adding user');
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding the contact person');
        } finally {
            setSubmittingForm(false);
        }
    }
    // Reset Form Fields
    const handleResetForm = () => {
        setAddUserInputValues({ ssoId: "", firstName: "", lastName: "", email: "", contactNumber: "", designation: "", password: "" });
        setSelectedAddUserProfessionalQualifications(null);
    }

    return (
        <>
            <Modal size='lg' isOpen={contactPersonAddModalOpen} toggle={toggleContactPersonAddModal}>
                <ModalHeader toggle={toggleContactPersonAddModal}>Add Contact Person</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-4">
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="ssoId" className="form-label">Username (SSO ID)</Label>
                                    <Input type="text" className="form-control" id="ssoId" placeholder='Enter username (SSO ID)' name='ssoId' value={addUserInputValues.ssoId} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="firstName" className="form-label">First Name</Label>
                                    <Input type="text" className="form-control" id="firstName" placeholder='Enter first name' name='firstName' value={addUserInputValues.firstName} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="lastName" className="form-label">Last Name</Label>
                                    <Input type="text" className="form-control" id="lastName" placeholder='Enter last name' name='lastName' value={addUserInputValues.lastName} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="email" className="form-label">Email Address</Label>
                                    <Input type="email" className="form-control" id="email" placeholder='Enter email address' name='email' value={addUserInputValues.email} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="contactNumber" className="form-label">Phone Number</Label>
                                    <Input type="text" className="form-control" id="contactNumber" placeholder='Enter phone number' name='contactNumber' value={addUserInputValues.contactNumber} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>

                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="designation" className="form-label">Designation</Label>
                                    <Input type="text" className="form-control" id="designation" placeholder='Enter designation' name='designation' value={addUserInputValues.designation} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="professionalQualification" className="form-label">Professional Qualifications</Label>
                                    <Input type="text" className="form-control" id="professionalQualification" placeholder='Enter professional qualification' name='professionalQualification' value={addUserInputValues.professionalQualification} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Label htmlFor="password" className="form-label">Password</Label>
                                    <Input type="password" className="form-control" id="password" name='password' placeholder='Enter password' value={addUserInputValues.password} onChange={(e) => handleContactPersonAddInputsChange(e)} disabled={submittingForm} />
                                </div>
                            </Col>
                            <Col lg={12}>
                                {
                                    submittingForm ? <Button color="primary" className="me-2" type='button' disabled>
                                        <Spinner size="sm"> Loading... </Spinner> </Button> : <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={handleAddUser}> Add  </Button>
                                }
                                <Button color="secondary" type='reset' onClick={handleResetForm} disabled={submittingForm}> Reset </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}
